<template>
  <div class="quality-img">
    <div class="quality-img-up">
      <el-button type="primary" plain>{{upLabel}}</el-button>
      <input class="up-input" type="file" accept="image/jpg,image/png,image/jpeg" @change="selectFile">
    </div>
    <div class="file-info">
      <span v-if="!value || typeof value == 'string'">{{desc || ''}}JPG或PNG格式，小于4M</span>
      <span v-else>{{fileName}}</span>
      <span class="main-text" v-if="isChange">待提交</span>
    </div>
  </div>
</template>
<script>
  const IMAGE_SIZE = 4 * 1024 * 1024;
  export default {
    name: 'quality-img',
    model: {
      prop: 'value',
      event: 'change'
    },
    props: {
      value: [String, File],
      desc: String
    },
    data() {
      return {
        fileName: '',
        isChange: false
      }
    },
    computed: {
      upLabel() {
        return this.value ? '重新上传' : '上传';
      }
    },
    methods: {
      selectFile(event) {
        const files = event.target.files;
        if (!files.length) return;
        const file = files[0];
        if (file.size > IMAGE_SIZE) {
          this.$alert('文件大小不能超过4M');
          return;
        } else if (!['image/jpg', 'image/png', 'image/jpeg'].includes(file.type)) {
          this.$alert('只支持jpg,png格式图片');
          return;
        }
        this.fileName = file.name;
        this.isChange = true;
        this.$emit('change', file);
      }
    }
  }
</script>
<style lang="scss">
  .quality-img {
    .quality-img-up {
      display: inline-block;
      position: relative;
      .el-button {
        width: 80px;
      }
      .up-input {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        opacity: 0;
      }
    }
    .file-info {
      display: inline-block;
      color: #888;
      font-size: 12px;
    }
  }
</style>